/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

(function () {

    /**
     * Handle scrollToTop
     * @param scrollToTopBtn {String} mainNav identifier
     * @method scrollToTop
     */
    function VideoStage(videoStage) {
        /**
         * local object availability
         * @type {ScrollToTop}
         * @private
         */
        var _this = this;

        /**
         * Holds the current viewport and is updated if the screen size changes
         * @type {string}
         */
        this.currentViewport = 'init';

        /**
         * Holds the video stage content element
         */
        this.videoStage = null;

        /**
         * Availavble viewports and the breakpoints to be used
         * @type {{tablet: number, desktop: number, mobile: number}}
         */
        this.viewports = {
            'desktop': {
                'breakpoint': 992
            },
            'tablet': {
                'breakpoint': 576,
                'fallback': 'desktop'
            },
            'mobile': {
                'breakpoint': 0,
                'fallback': 'tablet'
            }
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {

            _this.videoStage = videoStage;

            // No source switch is required if there is only one source
            if (_this.hasVideoMultipleSources) {
                _this.updateVideoOnViewportChange();

                window.addEventListener('resize', function () {
                    _this.updateVideoOnViewportChange();
                });
            }
        };

        /**
         * Checks if the video element has more than one source
         * @returns {boolean}
         */
        this.hasVideoMultipleSources = function() {
            video = _this.videoStage.querySelector('.js-video-stage__video');
            return video.children.length > 1;
        }

        /**
         * Updates the viewport and updates the video if required
         */
        this.updateVideoOnViewportChange = function() {
            var hasViewportChanged = _this.updateCurrentViewPort();
            if (hasViewportChanged) {
                _this.loadVideoSourceForBreakpoint();
            }
        }

        /**
         * Checks what viewport is used at the moment and returns if the viewport has changed
         * @returns {boolean}
         */
        this.updateCurrentViewPort = function()
        {
            var oldViewport = _this.currentViewport;

            var newViewport = '';

            if (window.innerWidth >= _this.viewports['desktop']['breakpoint']) {
                newViewport = 'desktop';
            } else if (window.innerWidth >= _this.viewports['tablet']['breakpoint']) {
                newViewport = 'tablet';
            } else {
                newViewport = 'mobile';
            }

            _this.currentViewport = newViewport;

            return oldViewport !== newViewport;
        }

        /**
         * Adjusts the order of the source elements of the video tag
         * Since the first source is used the element for the current viewport is placed at the first position
         * The video is reloaded to activate the change
         * If there is no video for the required viewport the desktop video is used as a fallback
         */
        this.loadVideoSourceForBreakpoint = function()
        {
            var video = _this.videoStage.querySelector('.js-video-stage__video');
            selectedSource = _this.getVideoSourceElement(video, _this.currentViewport);
            video.insertBefore(selectedSource, video.firstChild);
            video.load()
        }

        /**
         * Selects the source element to use for the given viewport
         * @param video
         * @param viewport
         * @returns {*}
         */
        this.getVideoSourceElement = function(video, viewport) {
            sourceElement = video.querySelector('.js-video-stage__source-' + viewport);
            if (sourceElement === null) {
                sourceElement = this.getVideoSourceElement(video, _this.viewports[viewport]['fallback']);
            }
            return sourceElement;
        }

        _this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.VideoStage = VideoStage;
})();

$(function () {
    var videoStages = document.querySelectorAll('.js-video-stage');
    if (videoStages) {
        videoStages.forEach(function (videoStage) {
            new window.Jumpers.VideoStage(videoStage);
        });

    }
});
